import { Avatar, AvatarFallback } from '@/components/ui/avatar'
import { ADJUSTER, CARRIER_NAME } from './claimsData'

/** The carrier's adjuster, relayed by the broker — Cai holds no adjuster record today. */
export function AdjusterCard() {
  return (
    <div className="border-ink-200 bg-surface mt-2.5 rounded-sm border p-3.5">
      <div className="flex items-center gap-2.5">
        <Avatar className="size-8.5">
          <AvatarFallback className="bg-ink-100 text-ink-700 text-sm font-bold">
            {ADJUSTER.initials}
          </AvatarFallback>
        </Avatar>
        <div>
          <div className="text-sm font-semibold">{ADJUSTER.name}</div>
          <div className="text-ink-500 text-xs">{ADJUSTER.meta}</div>
        </div>
      </div>
      <dl className="border-ink-200 mt-2.5 flex flex-wrap gap-x-5 gap-y-2 border-t pt-2.5">
        <div>
          <dt className="text-ink-400 font-mono text-[10px] tracking-[0.12em] uppercase">Phone</dt>
          <dd className="mt-0.5 text-xs font-semibold">{ADJUSTER.phone}</dd>
        </div>
        <div>
          <dt className="text-ink-400 font-mono text-[10px] tracking-[0.12em] uppercase">Email</dt>
          <dd className="mt-0.5 text-xs font-semibold">{ADJUSTER.email}</dd>
        </div>
        <div>
          <dt className="text-ink-400 font-mono text-[10px] tracking-[0.12em] uppercase">
            Quote this claim number
          </dt>
          <dd className="mt-0.5 text-xs font-semibold">{ADJUSTER.claimNumber}</dd>
        </div>
      </dl>
      <p className="text-ink-400 mt-2 text-xs">
        Relayed by your broker, Sep 1. This is {CARRIER_NAME}&apos;s number for the claim, not ours.
      </p>
    </div>
  )
}
